import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_WITH_TOKEN,
    LOGOUT_SUCCESS,
    LOGOUT,
    LOGIN_FAIL,
    ILoginFailAction,
    ILoginAction,
} from "../actions/login.actions";

import {
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
    IUserActions,
    ACTIVATE_ACCOUNT_SUCCESS,
    activateAccount,
    ACTIVATE_ACCOUNT_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    IUpdateUserSuccessAction,
    UPDATE_USER_REQUEST,
    UPDATE_USER_FAILURE,
    UPDATE_USER_PREFERENCES_REQUEST,
    IUpdateUserPreferencesRequestAction,
    UNASSIGN_USER_ROLE_REQUEST,
    UNASSIGN_USER_ROLE_SUCCESS,
    UNASSIGN_USER_ROLE_FAILURE,
} from "../actions/user.actions";

export type UserState = {
    loading: boolean;
    loggingIn: boolean;
    loginActive: boolean;
    loginError: any;
    currentUser: DTOS.User;
    loginStatusUnknown: boolean;
    accountActivated: boolean;
    activatingAccount: boolean;
    registeringAccount: boolean;
    updatingAccount: boolean;
    userRoleUnassignPending: boolean;
}

const initialState: UserState = {
    loading: false,
    loggingIn: false,
    loginActive: false,
    loginError: undefined,
    currentUser: undefined,
    loginStatusUnknown: true,
    accountActivated: undefined,
    activatingAccount: false,
    registeringAccount: undefined,
    updatingAccount: false,
    userRoleUnassignPending: false,
};

export default function user(state: UserState = initialState, action) {
    switch (action.type) {
        case CURRENT_USER_REQUEST:
            return loadingData(state, true);
        case CURRENT_USER_SUCCESS:
            return updateResults(state, action);
        case LOGOUT:
            return updateResults(state, action);
        case LOGIN:
            return loginRequest(state);
        case LOGIN_WITH_TOKEN:
            return loginRequest(state);
        case LOGIN_SUCCESS:
            return loggingIn(state, false);
        case LOGIN_FAIL:
            return loginFail(state, action);
        case ACTIVATE_ACCOUNT_SUCCESS:
            return accountActivated(state, action);
        case REGISTER_USER_REQUEST:
            return registerResult(state, true);
        case REGISTER_USER_SUCCESS:
            return registerResult(state, false);
        case UPDATE_USER_REQUEST:
            return setUpdatingUser(state, true);
        case UPDATE_USER_FAILURE:
            return setUpdatingUser(state, false);
        case UPDATE_USER_SUCCESS:
            return updateUser(state, action);
        case UPDATE_USER_PREFERENCES_REQUEST:
            return updateUserPreferences(state, action);
        case UNASSIGN_USER_ROLE_REQUEST:
            return setUnassigningUserRolePending(state, true);
        case UNASSIGN_USER_ROLE_SUCCESS:
        case UNASSIGN_USER_ROLE_FAILURE:
            return setUnassigningUserRolePending(state, false);
    }
    return state;
}

function registerResult(state: UserState, result: boolean) {
    const newState: UserState = update(state,
        {
            registeringAccount: { $set: result }
        });

    return newState;
}

function accountActivated(state: UserState, action: IUserActions) {
    const newState: UserState = update(state,
        {
            accountActivated: { $set: action.accountActivated }
        });

    return newState;
}

function loginFail(state: UserState, action: ILoginFailAction) {

    const newState: UserState = update(state, {
        loginError: { $set: action.responseStatus.errorCode }
    });

    return loggingIn(newState, false);
}

function loginRequest(state: UserState) {

    const newState: UserState = update(state, {
        loginError: { $set: undefined }
    });

    return loggingIn(newState, true);
}

function loggingIn(state: UserState, isLoading: boolean) {
    const newState: UserState = update(state, {
        loggingIn: { $set: isLoading }
    });

    return newState;
}

function loadingData(state: UserState, isLoading: boolean) {
    const newState: UserState = update(state, {
        loading: { $set: isLoading }
    });

    return newState;
}

function updateResults(state: UserState, action: IUserActions) {
    const newState: UserState = update(state, {
        currentUser: { $set: action.currentUser ? action.currentUser : undefined },
        loginActive: { $set: action.currentUser ? true : false },
        loginStatusUnknown: { $set: false }
    });

    return loadingData(newState, false);
}

function updateUser(state: UserState, action: IUpdateUserSuccessAction) {
    const newState: UserState = update(state, {
        currentUser: { $set: action.user }
    });

    return setUpdatingUser(newState, false);
}

function setUpdatingUser(state: UserState, updating: boolean) {
    const newState: UserState = update(state, {
        updatingAccount: { $set: updating }
    });

    return newState;
}

function setUnassigningUserRolePending(state: UserState, pending: boolean) {
    const newState: UserState = update(state, {
        userRoleUnassignPending: { $set: pending }
    });

    return newState;
}

function updateUserPreferences(state: UserState, action: IUpdateUserPreferencesRequestAction) {

    const newState: UserState = update(state, {
        currentUser: {
            userPreferences: {
                $set: action.preferences
            }
        }
    });

    return newState;
}